<div class="w-100-p" *ngIf="dataSource">
    <span id="ruler" class="ruler"></span>
    <mat-table #table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef class="pr-12">{{ 'GENERAL.PROPERTY.NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" class="pr-12">
                <span class="font-medium text-truncate">{{ performanceTeamReview.name }}</span>
            </mat-cell>
        </ng-container>

        <!-- Creator Column -->
        <ng-container matColumnDef="creator">
            <mat-header-cell *matHeaderCellDef class="pr-12">{{ 'GENERAL.PROPERTY.CREATOR' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" class="pr-12">
                <div *ngIf="performanceTeamReview.createdBy; else creator" class="text-truncate">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <div class="relative">
                            <img
                                *ngIf="performanceTeamReview.createdBy.profilePicture?.url; else initials"
                                class="avatar mr-0 mr-sm-16"
                                [src]="performanceTeamReview.createdBy.profilePicture.url"
                            />
                            <ng-template #initials>
                                <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ performanceTeamReview.createdBy.fullName | initials }}</div>
                            </ng-template>
                        </div>
                        <span class="username text-truncate">
                            {{ performanceTeamReview.createdBy.fullName }}
                        </span>
                    </div>
                </div>
                <ng-template #creator>
                    <span class="text-truncate">{{ performanceTeamReview.creator | translate }}</span>
                </ng-template>
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef class="pr-12">{{ 'GENERAL.PROPERTY.TYPE' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" class="pr-12">
                <span class="text-truncate">{{ performanceTeamReview.type.name | translate }}</span>
            </mat-cell>
        </ng-container>

        <!-- Due Date Column -->
        <ng-container matColumnDef="dueDate">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.DUE_DATE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" fxHide fxShow.gt-sm>
                <p
                    class="text-truncate mr-4"
                    [ngClass]="{
                        'text-red-700': performanceTeamReview.isOverdue,
                        'text-xs': performanceTeamReview.isOverdue,
                        'font-semibold': performanceTeamReview.isOverdue
                    }"
                >
                    {{ performanceTeamReview.dueDate | date: 'shortDate' }}
                </p>
                <mat-icon class="icon-18 text-red-700" *ngIf="performanceTeamReview.isOverdue">error</mat-icon>
            </mat-cell>
        </ng-container>

        <!-- Period Under Review Column -->
        <ng-container matColumnDef="periodUnderReview">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm class="pr-12"> {{ 'PERFORMANCE_REVIEW.PERIODS.PERIOD_UNDER_REVIEW' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" fxHide fxShow.gt-sm class="pr-12">
                <p class="text-truncate">
                    {{ performanceTeamReview.periodUnderReview.startDate | date: 'shortDate' }} - {{ performanceTeamReview.periodUnderReview.endDate | date: 'shortDate' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Number of Personal Reviews Column -->
        <ng-container matColumnDef="participants">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" fxHide fxShow.gt-sm>
                <p class="text-truncate">
                    {{ performanceTeamReview.numberOfPersonalReviews }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview" fxHide fxShow.gt-sm>
                <span
                    class="py-4 px-12 text-truncate uppercase rounded-full tracking-wider text-xs"
                    [style.color]="performanceTeamReview.status | getStatus: performanceTeamReviewStatus:'color'"
                    [style.background-color]="performanceTeamReview.status | getStatus: performanceTeamReviewStatus:'bgColor'"
                >
                    {{ performanceTeamReview.status | getStatus: performanceTeamReviewStatus:'translationLabel' | translate }}
                </span>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview">
                <div fxFlex="row" fxLayoutAlign="end center" *ngIf="performanceTeamReview.creator !== isCreatedFromAdminSpace">
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        (click)="$event.stopPropagation()"
                        (mouseenter)="onMouseEnter($event)"
                        (mouseleave)="onMouseLeave($event)"
                    >
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before" yPosition="below">
                        <app-menu-item-button
                            [svgIcon]="'edit'"
                            [label]="'GENERAL.BUTTON.EDIT'"
                            (onClick)="openEditPerformanceTeamReviewDialog(performanceTeamReview)"
                        ></app-menu-item-button>
                        <app-menu-item-button
                            [icon]="'delete'"
                            [label]="'GENERAL.BUTTON.DELETE'"
                            [showThreeDots]="true"
                            (onClick)="deletePerformanceTeamReview(performanceTeamReview)"
                        ></app-menu-item-button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Select action Column -->
        <ng-container matColumnDef="selectAction">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let performanceTeamReview">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <app-flat-button
                        [label]="'GENERAL.BUTTON.SELECT'"
                        (onClick)="$event.stopPropagation(); onSelect(performanceTeamReview)"
                        [disabled]="selectedNode && selectedNode?.id !== performanceTeamReview.id"
                        *ngIf="selectedNode?.id !== performanceTeamReview.id; else unselect"
                    ></app-flat-button>
                    <ng-template #unselect>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="$event.stopPropagation(); onDeselect(performanceTeamReview)"></app-white-button>
                    </ng-template>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
            *matRowDef="let performanceTeamReview; columns: displayedColumns"
            matRipple
            class="relative group py-8 pointer hover:bg-gray-50"
            (click)="isViewOnly ? null : openPerformanceTeamReviewDetailsPage(performanceTeamReview)"
        >
        </mat-row>
    </mat-table>

    <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="no-results-wrapper py-112 bg-white"
        *ngIf="!(filteredPerformanceTeamReviews$ | async)?.length && !(isFetchingPerformanceTeamReviewsList$ | async)"
    >
        <div class="no-results-container mb-32" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
            <h2>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
            <span>
                {{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}
            </span>
        </div>
    </div>

    <mat-paginator persistPageSize="preformance-team-reviews-list.preformance-team-reviews-list" [length]="performanceTeamReviewsStateTotalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
</div>
